import {useNavigate} from 'react-router-dom'
import {useCurrentUser} from '@/hooks/useCurrentUser'
import {AvatarButton} from '@/components/atoms'
import {ROUTES} from '@/shared/constants/routesConstants'

/**
 * A button component that displays a user avatar with the user's name and handles navigation on click
 * @param {Object} props - The component props
 * @returns {JSX.Element} UserAvatarButton component
 */
export function UserAvatarButton() {
  const {displayName} = useCurrentUser()
  const navigate = useNavigate()

  return <AvatarButton showArrowIcon={true} name={displayName} onClick={() => navigate(ROUTES.LOGOUT)} testId="header-user-avatar" type="text" />
}
